<ng-container *ngIf="showNewItemSpotlight$ | async">
  <bit-spotlight
    [title]="nudgeTitle"
    [subtitle]="nudgeBody"
    (onDismiss)="dismissNewItemSpotlight()"
  >
  </bit-spotlight>
</ng-container>
